// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","innerContainer":"Button_innerContainer__Micne","secondary":"Button_secondary__sUGsj","small":"Button_small__jToKs","loading":"Button_loading__5WK4e"};